// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/assets/images/logo_spotify.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/assets/images/logo_amazon-music.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/assets/images/logo_apple-music.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/assets/images/icon_profile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/assets/images/icon_discography.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/assets/images/icon_blog.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/assets/images/icon_schedule.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/assets/images/icon_sns--youtube.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/assets/images/icon_sns--instagram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/assets/images/icon_sns--x.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/assets/images/icon_sns--facebook.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/assets/images/icon_sns--tiktok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/assets/images/icon_chevron.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 
Theme Name: 伊谷亜子公式ホームページTheme
Author: 株式会社トータル・アシスト
*/
.wp-block-button__link {
  border-radius: 0;
}
.wp-block-button__link:hover {
  background-color: #9076C5 !important;
  border: 2px solid #181830 !important;
  color: #FFFFFF !important;
  transition: all 0.5s 0s ease;
}

html {
  scroll-behavior: smooth;
  height: 100%;
}

body {
  padding: 0;
}

.wp-site-blocks {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
}

.global-footer {
  flex-shrink: 0;
}

section {
  margin-block-start: 0 !important;
  padding: 3.5rem 0;
}
@media screen and (min-width: 600px) {
  section {
    padding: 5rem 0;
  }
}
section > *:not(h2, ul, iframe, .ako-hero-slide, .ako-latest-disc__inner, .ako-latest-disc__container, .ako-youtube .feedzy-rss) {
  max-width: 1040px !important;
  padding: 0 1rem;
}
@media screen and (min-width: 1040px) {
  section > *:not(h2, ul, iframe, .ako-hero-slide, .ako-latest-disc__inner, .ako-latest-disc__container, .ako-youtube .feedzy-rss) {
    padding: 0;
  }
}
section > h2 {
  max-width: 1040px !important;
}
section > ul {
  max-width: 1040px !important;
  padding: 0 1rem;
}
@media screen and (min-width: 1040px) {
  section > ul {
    padding: 0;
  }
}

a {
  color: #181830;
}
a:hover {
  color: #431F89;
}

.ako-links h2 {
  margin: 0 auto 2.5rem !important;
}
.ako-links__top--spotify, .ako-links__top--amazon-music, .ako-links__top--apple-music {
  flex: 1 1 0;
}
.ako-links__top--spotify a, .ako-links__top--amazon-music a, .ako-links__top--apple-music a {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  background-color: #FFFFFF !important;
  border: 4px solid #FFFFFF !important;
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
  line-height: 1;
  box-sizing: border-box;
}
.ako-links__top--spotify a:before, .ako-links__top--amazon-music a:before, .ako-links__top--apple-music a:before {
  display: inline-block;
  content: "";
  mask-size: 3rem 3rem;
  background-color: #181830;
  width: 3rem;
  height: 3rem;
}
.ako-links__top--spotify a:hover, .ako-links__top--amazon-music a:hover, .ako-links__top--apple-music a:hover {
  border: 0.25rem solid #FFED00 !important;
  background-color: #FFFFFF !important;
  color: #181830 !important;
  transition: all 0.5s 0s ease;
}
.ako-links__top--spotify a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.ako-links__top--amazon-music a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.ako-links__top--apple-music a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.ako-links__bottom {
  margin: 2.5rem auto 0 !important;
}
.ako-links__bottom figure {
  border: 0.25rem solid transparent;
  border-radius: 1rem;
  box-sizing: border-box;
  overflow: hidden;
}
.ako-links__bottom figure:hover {
  border: 0.25rem solid #FFED00;
  transition: all 0.5s 0s ease;
}
.ako-links__top, .ako-links__bottom {
  flex-direction: column;
}
@media screen and (min-width: 782px) {
  .ako-links__top, .ako-links__bottom {
    flex-direction: row;
  }
}
.ako-links__min {
  margin: 2.5rem 0 0 !important;
  padding: 2.5rem 0;
}
.ako-links__min p {
  margin: 0 0 1rem;
}

h1 {
  font-size: clamp(2.25rem, 1.5rem + 2.31vw, 3rem);
  padding: 2.5rem 0 0;
}
@media screen and (min-width: 782px) {
  h1 {
    padding: 5rem 0 0;
  }
}

h2 {
  font-size: clamp(2rem, 1.5rem + 1.54vw, 2.5rem);
}

h3 {
  font-size: clamp(1.5rem, 1rem + 1.54vw, 2rem);
}

h4 {
  font-size: clamp(1.25rem, 1rem + 0.77vw, 1.5rem);
}

h5 {
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem);
}

h6 {
  font-size: clamp(0.875rem, 0.75rem + 0.38vw, 1rem);
}

p,
li {
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem);
  line-height: 160%;
}

.controlled-line-break {
  display: inline;
}
@media screen and (min-width: 782px) {
  .controlled-line-break {
    display: inline-block;
  }
}

.ako-event-list__group {
  margin: 0;
  padding: 0;
}
.ako-event-list__item {
  list-style: none;
}
.ako-event-list__item--date {
  font-size: 1rem;
}
.ako-event-list__item--title {
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem) !important;
  margin: 0;
}

.tab-switcher__tab {
  border-bottom: 1px solid #181830;
  margin: 0 0 2.5rem;
}
.tab-switcher__tab ul {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  margin: 0;
  padding: 0;
}
.tab-switcher__tab ul li {
  border: 1px solid #181830;
  border-bottom: 0;
  box-sizing: content-box;
  list-style: none;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
}
.tab-switcher__tab ul li.current {
  background-color: #431F89;
  color: #FFFFFF;
}
.tab-switcher__tab ul li.current:hover {
  background-color: #431F89;
  transition: all 0.5s 0s ease;
}
.tab-switcher__tab ul li:hover {
  background-color: #9076C5;
  color: #FFFFFF;
  transition: all 0.5s 0s ease;
}
.tab-switcher__table {
  overflow: hidden;
}
.tab-switcher__table .table-item {
  height: 0;
  visibility: hidden;
  opacity: 0;
}
.tab-switcher__table .table-item.current {
  height: 100%;
  visibility: visible;
  opacity: 1;
  transition: all 0.5s 0s ease;
}
.tab-switcher__table .table-item h3 {
  margin: 0 0 2.5rem;
}
.tab-switcher__table .table-item h4 {
  font-size: clamp(0.875rem, 0.75rem + 0.38vw, 1rem);
}
.tab-switcher__table .table-item p {
  font-size: clamp(0.875rem, 0.75rem + 0.38vw, 1rem);
}

.form-general__container {
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: 600px;
  margin: 0 auto;
}
.form-general__container div p {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.form-general__container div p > label {
  font-weight: 700;
}
.form-general__container input[type=text],
.form-general__container input[type=email],
.form-general__container input[type=date],
.form-general__container input[type=number],
.form-general__container textarea {
  font-size: 1rem;
  padding: 0.75rem 0.5rem;
  box-sizing: border-box;
  width: 100%;
}
.form-general__container input[type=submit] {
  background: #431F89;
  border: 2px solid #431F89;
  color: #FFFFFF;
  font-size: 1.25rem;
  padding: 0.75rem 0.5rem;
  cursor: pointer;
}
.form-general__container input[type=submit]:hover {
  background-color: #9076C5;
  transition: all 0.5s 0s ease;
}
.form-general__concent-for-privacy-policy p {
  margin: 0 !important;
}
.form-general__concent-for-privacy-policy div p {
  font-size: 0.875rem;
  margin-top: 0.5rem !important;
}
.form-general__submit p {
  margin: 0 !important;
}

.wpcf7-list-item {
  margin: 0;
}

.wpcf7-radio {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.wpcf7-not-valid-tip {
  font-size: 0.875rem;
}

.global-footer {
  background: linear-gradient(#431F89, #181830);
  color: #FFFFFF;
  padding: 5rem 0;
}
.global-footer__inner {
  gap: 1.5rem !important;
  margin: 0 1rem auto;
}
@media screen and (min-width: 1200px) {
  .global-footer__inner {
    margin: 0 2.5rem auto;
  }
}
.global-footer__nav {
  gap: 1rem;
  justify-content: center;
}
.global-footer__nav a span {
  text-decoration: underline;
}
.global-footer__nav a:hover span {
  color: #FFED00;
  transition: all 0.5s 0s ease;
}
.global-footer p,
.global-footer span {
  font-size: 1rem !important;
  line-height: 140%;
}

.global-header {
  background: linear-gradient(#431F89, #181830);
  padding: 1rem 0;
}
.global-header__inner {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
  margin: 0 1rem auto;
  gap: 24px !important;
}
@media screen and (min-width: 600px) {
  .global-header__inner {
    justify-content: center !important;
  }
}
@media screen and (min-width: 1040px) {
  .global-header__inner {
    flex-wrap: nowrap !important;
    justify-content: space-between !important;
  }
}
@media screen and (min-width: 1200px) {
  .global-header__inner {
    margin: 0 2.5rem auto;
  }
}
.global-header__logo {
  min-width: 5rem !important;
  width: 5rem !important;
}
.global-header__nav {
  justify-content: space-between;
  gap: 1.5rem !important;
  order: 3;
  width: 100%;
}
@media screen and (min-width: 600px) {
  .global-header__nav {
    justify-content: center;
  }
}
@media screen and (min-width: 1040px) {
  .global-header__nav {
    gap: 2rem !important;
    order: 2;
  }
}
@media screen and (min-width: 1200px) {
  .global-header__nav {
    gap: 2.5rem !important;
  }
}
.global-header__nav--profile, .global-header__nav--discography, .global-header__nav--blog, .global-header__nav--schedule {
  flex: 0 1 calc((100% - 4.5rem) / 4);
}
@media screen and (min-width: 600px) {
  .global-header__nav--profile, .global-header__nav--discography, .global-header__nav--blog, .global-header__nav--schedule {
    flex: 0 1 auto;
  }
}
.global-header__nav--profile a, .global-header__nav--discography a, .global-header__nav--blog a, .global-header__nav--schedule a {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
@media screen and (min-width: 600px) {
  .global-header__nav--profile a, .global-header__nav--discography a, .global-header__nav--blog a, .global-header__nav--schedule a {
    flex-direction: row;
  }
}
.global-header__nav--profile a span, .global-header__nav--discography a span, .global-header__nav--blog a span, .global-header__nav--schedule a span {
  color: #FFFFFF;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
}
@media screen and (min-width: 600px) {
  .global-header__nav--profile a span, .global-header__nav--discography a span, .global-header__nav--blog a span, .global-header__nav--schedule a span {
    font-size: 1rem;
  }
}
.global-header__nav--profile a:before, .global-header__nav--discography a:before, .global-header__nav--blog a:before, .global-header__nav--schedule a:before {
  content: "";
  display: inline-block;
  mask-size: 2rem 2rem;
  background-color: #FFFFFF;
  width: 2rem;
  height: 2rem;
  margin: 0 0 0.5rem 0;
}
@media screen and (min-width: 600px) {
  .global-header__nav--profile a:before, .global-header__nav--discography a:before, .global-header__nav--blog a:before, .global-header__nav--schedule a:before {
    margin: 0 0.5rem 0 0;
  }
}
.global-header__nav--profile a:hover span, .global-header__nav--discography a:hover span, .global-header__nav--blog a:hover span, .global-header__nav--schedule a:hover span {
  color: #FFED00;
  transition: all 0.5s 0s ease;
}
.global-header__nav--profile a:hover:before, .global-header__nav--discography a:hover:before, .global-header__nav--blog a:hover:before, .global-header__nav--schedule a:hover:before {
  background-color: #FFED00;
  transition: all 0.5s 0s ease;
}
.global-header__nav--profile a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.global-header__nav--discography a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.global-header__nav--blog a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.global-header__nav--schedule a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.global-header__collective {
  gap: 0.5rem !important;
  order: 2;
}
@media screen and (min-width: 1040px) {
  .global-header__collective {
    order: 3;
  }
}
.global-header__sns {
  gap: 0.5rem !important;
}
.global-header__sns a svg {
  display: none;
}
.global-header__sns a:before {
  content: "";
  display: inline-block;
  mask-size: 1.5rem 1.5rem;
  background-color: #FFFFFF;
  width: 1.5rem;
  height: 1.5rem;
}
@media screen and (min-width: 600px) {
  .global-header__sns a:before {
    mask-size: 1.5rem 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
}
.global-header__sns a:hover:before {
  background-color: #FFED00;
  transition: all 0.5s 0s ease;
}
.global-header__sns--youtube a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.global-header__sns--instagram a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.global-header__sns--x a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.global-header__sns--facebook a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.global-header__sns--tiktok a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.global-header__subnav {
  gap: 1rem !important;
}
.global-header__subnav li {
  line-height: 1;
}
.global-header__subnav a {
  display: inline-block;
  background-color: rgba(225, 255, 255, 0.28);
  border-radius: 0.25rem;
  padding: 0.5rem;
}
.global-header__subnav a span {
  color: #FFFFFF;
  font-size: 0.75rem;
  font-weight: 700;
}
.global-header__subnav a:hover {
  background-color: #FFED00;
  transition: all 0.5s 0s ease;
}
.global-header__subnav a:hover span:hover {
  color: #181830;
  transition: all 0.5s 0s ease;
}
.global-header__subnav--store {
  font-size: 0.75rem !important;
}

.wp-social-link {
  background-color: transparent !important;
}

.page__gallery .ako-gallery__group {
  flex-direction: column;
  gap: 2.5rem !important;
}
@media screen and (min-width: 600px) {
  .page__gallery .ako-gallery__group {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.page__gallery .ako-gallery__group .wp-block-image {
  flex: 0 0 calc(100% - 2rem) !important;
  width: unset !important;
  overflow: hidden;
  aspect-ratio: 1/1;
}
@media screen and (min-width: 600px) {
  .page__gallery .ako-gallery__group .wp-block-image {
    flex: 0 0 calc((100% - 2.5rem) / 2) !important;
  }
}
@media screen and (min-width: 782px) {
  .page__gallery .ako-gallery__group .wp-block-image {
    flex: 0 0 calc((100% - 5rem) / 3) !important;
  }
}
@media screen and (min-width: 1040px) {
  .page__gallery .ako-gallery__group .wp-block-image {
    flex: 0 0 calc((100% - 7.5rem) / 4) !important;
  }
}

.home h2 {
  margin: 0 auto 2.5rem !important;
}

.ako-hero-slide {
  background-color: #181830;
  margin: 0 auto;
}
.ako-hero-slide__inner {
  max-width: 1600px !important;
  max-height: 900px !important;
}
.ako-hero-slide .flex-viewport {
  max-height: 900px !important;
}

.ako-hero-slide .flexslider,
.ako-latest-disc .flexslider {
  margin: 0;
  position: relative;
  overflow: hidden;
}
.ako-hero-slide .flexslider .flex-viewport,
.ako-hero-slide .flexslider .flex-control-nav,
.ako-latest-disc .flexslider .flex-viewport,
.ako-latest-disc .flexslider .flex-control-nav {
  position: absolute;
}
.ako-hero-slide .flexslider .flex-control-nav,
.ako-latest-disc .flexslider .flex-control-nav {
  bottom: 2.5rem;
}
.ako-hero-slide .flexslider .flex-control-nav li a,
.ako-latest-disc .flexslider .flex-control-nav li a {
  width: 1rem;
  height: 1rem;
  background: #FFFFFF;
  margin: 0 0.5rem;
}
.ako-hero-slide .flexslider .flex-control-nav li a.flex-active,
.ako-latest-disc .flexslider .flex-control-nav li a.flex-active {
  background: #431F89;
  border: 2px solid #FFFFFF;
}
.ako-hero-slide .flexslider .flex-prev,
.ako-hero-slide .flexslider .flex-next,
.ako-hero-slide .flexslider .flex-prev:focus,
.ako-hero-slide .flexslider .flex-next:focus,
.ako-latest-disc .flexslider .flex-prev,
.ako-latest-disc .flexslider .flex-next,
.ako-latest-disc .flexslider .flex-prev:focus,
.ako-latest-disc .flexslider .flex-next:focus {
  width: 2.5rem !important;
  height: 2.5rem !important;
  background-size: cover !important;
}
.ako-hero-slide .flexslider .flex-prev,
.ako-hero-slide .flexslider .flex-prev:focus,
.ako-latest-disc .flexslider .flex-prev,
.ako-latest-disc .flexslider .flex-prev:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
}
.ako-hero-slide .flexslider .flex-next,
.ako-hero-slide .flexslider .flex-next:focus,
.ako-latest-disc .flexslider .flex-next,
.ako-latest-disc .flexslider .flex-next:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) !important;
  transform: rotate(180deg);
}
.ako-hero-slide .flexslider .flex-prev,
.ako-hero-slide .flexslider .flex-next,
.ako-latest-disc .flexslider .flex-prev,
.ako-latest-disc .flexslider .flex-next {
  opacity: 0.75 !important;
}
.ako-hero-slide .flexslider .flex-prev:hover, .ako-hero-slide .flexslider .flex-prev:focus,
.ako-hero-slide .flexslider .flex-next:hover,
.ako-hero-slide .flexslider .flex-next:focus,
.ako-latest-disc .flexslider .flex-prev:hover,
.ako-latest-disc .flexslider .flex-prev:focus,
.ako-latest-disc .flexslider .flex-next:hover,
.ako-latest-disc .flexslider .flex-next:focus {
  opacity: 1 !important;
  transition: all 0.5s 0s ease;
}

.ako-latest-disc {
  background: linear-gradient(#000, #181830);
}
.ako-latest-disc h2 {
  color: #FFFFFF;
  font-size: clamp(1.5rem, 1rem + 1.54vw, 2rem);
  margin: 0 0 1.5rem !important;
}
.ako-latest-disc h4 {
  font-size: 16px;
  margin: 1rem 0 0 !important;
}
.ako-latest-disc a {
  color: #FFFFFF;
}
.ako-latest-disc a:hover {
  color: #FFED00;
}
.ako-latest-disc__inner {
  padding: 0 1rem;
  flex-direction: column;
}
@media screen and (min-width: 600px) {
  .ako-latest-disc__inner {
    padding: 0 0 0 1rem;
    flex-direction: row;
  }
}
@media screen and (min-width: 782px) {
  .ako-latest-disc__inner {
    padding: 0 0 0 2.5rem;
    flex-direction: row;
  }
}
@media screen and (min-width: 2000px) {
  .ako-latest-disc__inner {
    padding: 0 0 0 5rem;
    flex-direction: row;
  }
}
.ako-latest-disc__container {
  overflow: scroll;
  max-width: 100% !important;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.ako-latest-disc__container:-webkit-scrollbar {
  display: none;
}
.ako-latest-disc__container.active {
  cursor: ew-resize;
}
.ako-latest-disc__post {
  display: flex !important;
  flex-direction: row;
  width: max-content;
  box-sizing: content-box;
}
.ako-latest-disc .wp-block-post-template {
  max-width: none;
}
.ako-latest-disc__item {
  width: 320px;
}
.ako-latest-disc__item img {
  user-drag: none;
  -webkit-user-drag: none;
  -moz-user-select: none;
}
.ako-latest-disc .wp-block-button__link {
  color: #FFFFFF !important;
}

.ako-youtube {
  padding: 2.5rem 0;
}
@media screen and (min-width: 782px) {
  .ako-youtube {
    padding: 5rem 0;
  }
}
.ako-youtube .feedzy-rss {
  width: 100%;
  height: 100%;
  margin: 0 auto 2.5rem !important;
}
.ako-youtube .feedzy-rss ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  margin: 0 !important;
}
@media screen and (min-width: 782px) {
  .ako-youtube .feedzy-rss ul {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
}
.ako-youtube .feedzy-rss ul li {
  border-bottom: none !important;
  margin: 0 !important;
  padding: 0 !important;
}
.ako-youtube .feedzy-rss ul li:first-child {
  grid-area: 1/1/3/3;
}
.ako-youtube .feedzy-rss ul li:nth-child(2) {
  grid-area: 3/1/5/3;
}
.ako-youtube .feedzy-rss ul li:nth-child(3) {
  grid-area: 5/1/6/2;
}
.ako-youtube .feedzy-rss ul li:nth-child(4) {
  grid-area: 5/2/6/3;
}
.ako-youtube .feedzy-rss ul li:nth-child(5) {
  grid-area: 6/1/7/2;
}
.ako-youtube .feedzy-rss ul li:last-child {
  grid-area: 6/2/7/3;
}
@media screen and (min-width: 782px) {
  .ako-youtube .feedzy-rss ul li:first-child {
    grid-area: 1/1/3/3;
  }
  .ako-youtube .feedzy-rss ul li:nth-child(2) {
    grid-area: 1/3/2/4;
  }
  .ako-youtube .feedzy-rss ul li:nth-child(3) {
    grid-area: 2/3/3/4;
  }
  .ako-youtube .feedzy-rss ul li:nth-child(4) {
    grid-area: 3/1/4/2;
  }
  .ako-youtube .feedzy-rss ul li:nth-child(5) {
    grid-area: 3/2/4/3;
  }
  .ako-youtube .feedzy-rss ul li:last-child {
    grid-area: 3/3/4/4;
  }
}
.ako-youtube .feedzy-rss ul li a {
  display: inline-block;
  width: 100% !important;
  height: 100% !important;
}
.ako-youtube .feedzy-rss ul li .title {
  display: none;
}
.ako-youtube .feedzy-rss ul li .rss_content {
  display: none;
}
.ako-youtube .feedzy-rss ul li .rss_content small {
  display: none;
}
.ako-youtube .feedzy-rss ul li .rss_image {
  width: 100% !important;
  height: 100% !important;
}

.ako-sns .feedzy-rss,
.ako-sns #sb_instagram {
  margin: 0 auto 2.5rem !important;
}
.ako-sns__ameblo ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  margin: 0;
}
@media screen and (min-width: 782px) {
  .ako-sns__ameblo ul {
    flex-direction: row;
    align-items: flex-start;
  }
}
.ako-sns__ameblo ul:before, .ako-sns__ameblo ul:after {
  content: none;
}
.ako-sns__ameblo ul .rss_item {
  border-bottom: none !important;
  display: flex !important;
  flex-direction: column;
  max-width: 320px;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
}
@media screen and (min-width: 782px) {
  .ako-sns__ameblo ul .rss_item {
    overflow: hidden;
    flex: 1 1 calc(33.33% - 5rem);
  }
}
.ako-sns__ameblo .rss_image {
  border-radius: 0.5rem;
  margin: 0 0 1.5rem 0 !important;
  position: unset !important;
}
.ako-sns__ameblo .rss_image a {
  position: unset !important;
  display: inline-block;
  width: 320px;
  height: 320px;
}
.ako-sns__ameblo .rss_image a img {
  width: auto !important;
  height: 100%;
}
.ako-sns__ameblo .title {
  order: 2;
  font-size: 1.25rem;
}
.ako-sns__ameblo .rss_content {
  order: 1;
}
.ako-sns__ameblo .rss_content small {
  font-size: 1rem !important;
  font-style: normal !important;
  margin: 0 0 0.5rem 0;
}
.ako-sns__instagram #sbi_images {
  float: none !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
}
@media screen and (min-width: 782px) {
  .ako-sns__instagram #sbi_images {
    flex-direction: row;
  }
}
.ako-sns__instagram .sbi_item {
  border-radius: 0.5rem;
  max-width: 320px !important;
  width: 100% !important;
}
@media screen and (min-width: 782px) {
  .ako-sns__instagram .sbi_item {
    width: 33%;
  }
}
.ako-sns__instagram #sbi_load,
.ako-sns__instagram .sb_instagram_header {
  display: none;
}

.page__profile .ako-profile-hero {
  min-height: 320px;
  height: 100%;
  margin: 2.5rem 0 120px;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-profile-hero {
    min-height: 320px;
  }
}
@media screen and (min-width: 782px) {
  .page__profile .ako-profile-hero {
    min-height: 400px;
    margin: 5rem 0 120px;
  }
}
@media screen and (min-width: 1200px) {
  .page__profile .ako-profile-hero {
    min-height: 660px;
  }
}
.page__profile .ako-profile-hero img {
  height: 64% !important;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-profile-hero img {
    height: 100% !important;
  }
}
.page__profile .ako-profile-hero__container {
  flex-direction: column !important;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-profile-hero__container {
    flex-direction: row !important;
  }
}
.page__profile .ako-profile-hero__left {
  padding: 160px;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-profile-hero__left {
    padding: 0;
  }
}
.page__profile .ako-profile-hero__right h2 {
  float: left;
  margin: 0 0.5rem 0 0;
}
.page__profile .ako-profile-hero__right h3 {
  font-weight: 400;
  margin: 0.75rem 0 0;
}
.page__profile .ako-profile-hero__right p {
  clear: both;
  color: #999999;
  margin: 0;
}
.page__profile .ako-profile-hero__sns {
  gap: 0.5rem !important;
}
.page__profile .ako-profile-hero__sns a svg {
  display: none;
}
.page__profile .ako-profile-hero__sns a:before {
  content: "";
  display: inline-block;
  mask-size: 1.5rem 1.5rem;
  background-color: #181830;
  width: 1.5rem;
  height: 1.5rem;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-profile-hero__sns a:before {
    mask-size: 2rem 2rem;
    width: 2rem;
    height: 2rem;
  }
}
.page__profile .ako-profile-hero__sns a:hover:before {
  background-color: #9076C5;
  transition: all 0.5s 0s ease;
}
.page__profile .ako-profile-hero__sns--youtube a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.page__profile .ako-profile-hero__sns--instagram a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.page__profile .ako-profile-hero__sns--x a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.page__profile .ako-profile-hero__sns--facebook a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.page__profile .ako-profile-hero__sns--tiktok a:before {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.page__profile .ako-intro {
  max-width: 2000px;
  margin: 0 auto;
}
.page__profile .ako-intro .wp-block-media-text {
  overflow: hidden;
  padding: 0 1rem;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-intro .wp-block-media-text {
    padding: 0 1rem;
  }
}
@media screen and (min-width: 782px) {
  .page__profile .ako-intro .wp-block-media-text {
    padding: 0 2.5rem;
  }
}
@media screen and (min-width: 2000px) {
  .page__profile .ako-intro .wp-block-media-text {
    padding: 0;
  }
}
.page__profile .ako-intro .wp-block-media-text:first-child figure, .page__profile .ako-intro .wp-block-media-text:last-child figure {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page__profile .ako-intro .wp-block-media-text:first-child img {
  width: 100%;
  max-width: 444px;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-intro .wp-block-media-text:first-child img {
    max-width: 444px;
  }
}
@media screen and (min-width: 782px) {
  .page__profile .ako-intro .wp-block-media-text:first-child img {
    max-width: 444px;
  }
}
@media screen and (min-width: 1040px) {
  .page__profile .ako-intro .wp-block-media-text:first-child img {
    max-width: 444px;
  }
}
@media screen and (min-width: 1200px) {
  .page__profile .ako-intro .wp-block-media-text:first-child img {
    max-width: 888px;
  }
}
.page__profile .ako-intro .wp-block-media-text:last-child img {
  width: 100%;
  max-width: 400px;
}
@media screen and (min-width: 600px) {
  .page__profile .ako-intro .wp-block-media-text:last-child img {
    max-width: 400px;
  }
}
@media screen and (min-width: 782px) {
  .page__profile .ako-intro .wp-block-media-text:last-child img {
    max-width: 400px;
  }
}
@media screen and (min-width: 1040px) {
  .page__profile .ako-intro .wp-block-media-text:last-child img {
    max-width: 400px;
  }
}
@media screen and (min-width: 1200px) {
  .page__profile .ako-intro .wp-block-media-text:last-child img {
    max-width: 800px;
  }
}
.page__profile .ako-extra {
  padding: 0;
}
.page__profile .ako-extra__items h4 {
  color: #9076C5;
  margin: 0 0 1rem;
}
.page__profile .ako-extra__items p {
  margin: 0 0 2.5rem;
}
.page__profile .ako-snapshots {
  gap: 0 !important;
  margin: 0;
}
.page__profile .ako-history__group {
  border-bottom: 1px solid #181830;
  padding: 2.5rem 1rem !important;
}
@media screen and (min-width: 782px) {
  .page__profile .ako-history__group {
    padding: 3.5rem 2.5rem !important;
  }
}
@media screen and (min-width: 1040px) {
  .page__profile .ako-history__group {
    padding: 3.5rem 0 !important;
  }
}
.page__profile .ako-history__group--left {
  font-size: clamp(1.25rem, 0.977rem + 1.36vw, 2rem);
  min-width: 80px;
}
@media screen and (min-width: 782px) {
  .page__profile .ako-history__group--left {
    min-width: 258px;
  }
}
.page__profile .ako-history__group--right h4 {
  color: #9076C5;
  font-size: clamp(0.875rem, 0.75rem + 0.38vw, 1rem);
  margin: 0 0 0.5rem;
}
.page__profile .ako-history__group--right ul {
  margin: 0 0 2.5rem;
  padding: 0;
}
@media screen and (min-width: 782px) {
  .page__profile .ako-history__group--right ul {
    margin: 0 0 5rem;
  }
}
.page__profile .ako-history__group--right ul:last-child {
  margin: 0;
}
.page__profile .ako-history__group--right ul li {
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem);
  margin: 0 0 1rem 1.5rem !important;
}

.ako-schedule__table ul {
  max-width: 782px;
  margin: 0 auto 2.5rem !important;
}
.ako-schedule__table ul li {
  border-bottom: 1px solid #181830;
  margin: 0;
  padding: 1rem;
}
.ako-schedule__table ul li:first-child {
  border-top: 1px solid #181830;
}
.ako-schedule__table .tribe-events-schedule__datetime {
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0 0 0.5rem !important;
}
.ako-schedule__table .tribe-events-schedule__datetime > *:not(span:first-child) {
  display: none;
}
.ako-schedule__table h4 {
  font-size: clamp(1rem, 0.75rem + 0.77vw, 1.25rem) !important;
  margin: 0;
}
.ako-schedule__table a {
  color: #181830;
}
.ako-schedule__table a:hover {
  color: #431F89;
}

.single-tribe_events .tribe-events-schedule {
  background-color: #F2F2F2;
  border: 1px solid #D9D9D9;
  border-radius: 0.5rem;
  margin: 1.5rem 0 5rem;
  padding: 0.5rem 1rem 1.5rem;
  text-align: center;
}

.wp-site-blocks > * + * {
  margin-block-start: 0;
}

.wp-block-group.is-layout-constrained > * + * {
  margin-block-start: 0;
}

.wp-block-columns {
  box-sizing: unset;
}

.wp-block-group {
  box-sizing: unset;
}

.wp-block-media-text {
  box-sizing: unset;
}
.wp-block-media-text__content {
  padding: 0 !important;
}

:where(body .is-layout-flex),
:where(body .is-layout-grid),
.wp-block-media-text {
  gap: clamp(1rem, -0.039rem + 5.19vw, 2.5rem) !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./src/scss/01-atoms/_button.scss","webpack://./src/scss/01-atoms/_layout.scss","webpack://./src/scss/01-atoms/_link.scss","webpack://./src/scss/00-global/_palette.scss","webpack://./src/scss/00-global/_dimensions.scss","webpack://./src/scss/01-atoms/_typography.scss","webpack://./src/scss/02-molecules/_post-list.scss","webpack://./src/scss/02-molecules/_tab.scss","webpack://./src/scss/03-organisms/_form.scss","webpack://./src/scss/03-organisms/_global-footer.scss","webpack://./src/scss/03-organisms/_global-header.scss","webpack://./src/scss/05-pages/_gallery.scss","webpack://./src/scss/05-pages/_home.scss","webpack://./src/scss/05-pages/_profile.scss","webpack://./src/scss/05-pages/_schedule.scss","webpack://./src/scss/06-overrides/_wp-blocks.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;CAAA;ACEA;EACE,gBAAA;ADIF;ACFE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,4BAAA;ADIJ;;AEXA;EACE,uBAAA;EACA,YAAA;AFcF;;AEXA;EACE,UAAA;AFcF;;AEXA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AFcF;;AEXA;EACE,OAAA;AFcF;;AEXA;EACE,cAAA;AFcF;;AEXA;EACE,gCAAA;EACA,iBAAA;AFcF;AEZE;EAJF;IAKI,eAAA;EFeF;AACF;AEbE;EACE,4BAAA;EACA,eAAA;AFeJ;AEbI;EAJF;IAKI,UAAA;EFgBJ;AACF;AEbE;EACE,4BAAA;AFeJ;AEZE;EACE,4BAAA;EACA,eAAA;AFcJ;AEZI;EAJF;IAKI,UAAA;EFeJ;AACF;;AGnEA;EACE,cAAA;AHsEF;AGpEE;EACE,cCJU;AJ0Ed;;AGjEE;EACE,gCAAA;AHoEJ;AGhEI;EAGE,WAAA;AHgEN;AG9DM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WETE;EFUF,oCAAA;EACA,oCAAA;EACA,qBEZE;EFaF,oBAAA;EACA,cAAA;EACA,sBAAA;AHgER;AG9DQ;EACE,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBClCW;EDmCX,WEXC;EFYD,YEZC;AL4EX;AG7DQ;EACE,wCAAA;EACA,oCAAA;EACA,yBAAA;EACA,4BAAA;AH+DV;AGxDQ;EACE,mDAAA;AH0DV;AGnDQ;EACE,mDAAA;AHqDV;AG9CQ;EACE,mDAAA;AHgDV;AG1CE;EACE,gCAAA;AH4CJ;AG1CI;EACE,iCAAA;EACA,mBE9DK;EF+DL,sBAAA;EACA,gBAAA;AH4CN;AG1CM;EACE,6BAAA;EACA,4BAAA;AH4CR;AGvCE;EAEE,sBAAA;AHwCJ;AGrCI;EALF;IAMI,mBAAA;EHwCJ;AACF;AGrCE;EACE,6BAAA;EACA,iBAAA;AHuCJ;AGrCI;EACE,gBAAA;AHuCN;;AMhJA;EACE,gDAAA;EACA,mBAAA;ANmJF;AMjJE;EAJF;IAKI,iBAAA;ENoJF;AACF;;AMjJA;EACE,+CAAA;ANoJF;;AMjJA;EACE,6CAAA;ANoJF;;AMjJA;EACE,gDAAA;ANoJF;;AMjJA;EACE,iDAAA;ANoJF;;AMjJA;EACE,kDAAA;ANoJF;;AMjJA;;EAEE,iDAAA;EACA,iBAAA;ANoJF;;AMjJA;EACE,eAAA;ANoJF;AMlJE;EAHF;IAII,qBAAA;ENqJF;AACF;;AO5LE;EACE,SAAA;EACA,UAAA;AP+LJ;AO5LE;EACE,gBAAA;AP8LJ;AO5LI;EACE,eFOK;ALuLX;AO3LI;EACE,4DAAA;EACA,SAAA;AP6LN;;AQvME;EACE,gCAAA;EACA,kBAAA;AR0MJ;AQxMI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SHIK;EGHL,SAAA;EACA,UAAA;AR0MN;AQxMM;EACE,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AR0MR;AQxMQ;EACE,yBJ1BI;EI2BJ,cJhBF;AJ0NR;AQxMU;EACE,yBJ9BE;EI+BF,4BAAA;AR0MZ;AQtMQ;EACE,yBJrCU;EIsCV,cJ1BF;EI2BE,4BAAA;ARwMV;AQlME;EACE,gBAAA;ARoMJ;AQlMI;EACE,SAAA;EACA,kBAAA;EACA,UAAA;ARoMN;AQlMM;EACE,YAAA;EACA,mBAAA;EACA,UAAA;EACA,4BAAA;ARoMR;AQjMM;EACE,kBAAA;ARmMR;AQhMM;EACE,kDAAA;ARkMR;AQ/LM;EACE,kDAAA;ARiMR;;ASpQE;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EACA,gBJJc;EIKd,cAAA;ATuQJ;ASpQM;EACE,aAAA;EACA,sBAAA;EACA,WJEE;ALoQV;ASpQQ;EACE,gBAAA;ATsQV;AS/PI;;;;;EAKE,eJVK;EIWL,uBAAA;EACA,sBAAA;EACA,WAAA;ATiQN;AS9PI;EACE,mBLlCQ;EKmCR,yBAAA;EACA,cLzBE;EK0BF,kBJlBK;EImBL,uBAAA;EACA,eAAA;ATgQN;AS9PM;EACE,yBL3CY;EK4CZ,4BAAA;ATgQR;ASnNI;EACE,oBAAA;ATqNN;ASjNM;EACE,mBJ9EG;EI+EH,6BAAA;ATmNR;AS7MI;EACE,oBAAA;AT+MN;;ASzMA;EACE,SAAA;AT4MF;;ASzMA;EACE,aAAA;EACA,mBAAA;EACA,SJlGS;AL8SX;;ASzMA;EACE,mBJvGS;ALmTX;;AUnUA;EACE,6CAAA;EACA,cNSM;EMRN,eAAA;AVsUF;AUpUE;EACE,sBAAA;EACA,mBAAA;AVsUJ;AUpUI;EAJF;IAKI,qBAAA;EVuUJ;AACF;AUpUE;EACE,SLEO;EKDP,uBAAA;AVsUJ;AUnUM;EACE,0BAAA;AVqUR;AUjUQ;EACE,cNtBM;EMuBN,4BAAA;AVmUV;AU5TE;;EAEE,0BAAA;EACA,iBAAA;AV8TJ;;AWlWA;EACE,6CAAA;EACA,eAAA;AXqWF;AWnWE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,yCAAA;EACA,mBAAA;EACA,oBAAA;AXqWJ;AWnWI;EARF;IASI,kCAAA;EXsWJ;AACF;AWpWI;EAZF;IAaI,4BAAA;IACA,yCAAA;EXuWJ;AACF;AWrWI;EAjBF;IAkBI,qBAAA;EXwWJ;AACF;AWrWE;EACE,0BAAA;EACA,sBAAA;AXuWJ;AWpWE;EACE,8BAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AXsWJ;AWpWI;EANF;IAOI,uBAAA;EXuWJ;AACF;AWrWI;EAVF;IAWI,oBAAA;IACA,QAAA;EXwWJ;AACF;AWtWI;EAfF;IAgBI,sBAAA;EXyWJ;AACF;AWvWI;EAIE,mCAAA;AXsWN;AWpWM;EANF;IAOI,cAAA;EXuWN;AACF;AWrWM;EACE,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AXuWR;AWrWQ;EANF;IAOI,mBAAA;EXwWR;AACF;AWtWQ;EACE,cP5DF;EO6DE,kBNzDC;EM0DD,gBAAA;EACA,cAAA;AXwWV;AWtWU;EANF;IAOI,eN5DD;ELqaT;AACF;AWtWQ;EACE,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBP1EF;EO2EE,WNhEC;EMiED,YNjEC;EMkED,oBAAA;AXwWV;AWtWU;EATF;IAUI,oBAAA;EXyWV;AACF;AWrWU;EACE,cP9FI;EO+FJ,4BAAA;AXuWZ;AWpWU;EACE,yBPnGI;EOoGJ,4BAAA;AXsWZ;AW9VQ;EACE,mDAAA;AXgWV;AWzVQ;EACE,mDAAA;AX2VV;AWpVQ;EACE,mDAAA;AXsVV;AW/UQ;EACE,mDAAA;AXiVV;AW3UE;EACE,sBAAA;EACA,QAAA;AX6UJ;AW3UI;EAJF;IAKI,QAAA;EX8UJ;AACF;AW3UE;EACE,sBAAA;AX6UJ;AW1UM;EACE,aAAA;AX4UR;AWzUM;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBPxJA;EOyJA,aNhJG;EMiJH,cNjJG;AL4dX;AWzUQ;EARF;IASI,wBAAA;IACA,aNrJC;IMsJD,cNtJC;ELkeT;AACF;AWvUQ;EACE,yBP9KM;EO+KN,4BAAA;AXyUV;AWlUQ;EACE,mDAAA;AXoUV;AW7TQ;EACE,mDAAA;AX+TV;AWxTQ;EACE,mDAAA;AX0TV;AWnTQ;EACE,oDAAA;AXqTV;AW9SQ;EACE,oDAAA;AXgTV;AW1SE;EACE,oBAAA;AX4SJ;AW1SI;EACE,cAAA;AX4SN;AWzSI;EACE,qBAAA;EACA,2CAAA;EACA,sBN7NI;EM8NJ,eN7NI;ALwgBV;AWzSM;EACE,cPnOA;EOoOA,kBNhOG;EMiOH,gBAAA;AX2SR;AWxSM;EACE,yBPjPQ;EOkPR,4BAAA;AX0SR;AWvSU;EACE,cPxPS;EOyPT,4BAAA;AXySZ;AWnSI;EACE,6BAAA;AXqSN;;AW/RA;EACE,wCAAA;AXkSF;;AYtiBI;EACE,sBAAA;EACA,sBAAA;AZyiBN;AYviBM;EAJF;IAKI,mBAAA;IACA,eAAA;EZ0iBN;AACF;AYxiBM;EACE,sCAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AZ0iBR;AYviBQ;EAPF;IAQI,8CAAA;EZ0iBR;AACF;AYxiBQ;EAXF;IAYI,4CAAA;EZ2iBR;AACF;AYziBQ;EAfF;IAgBI,8CAAA;EZ4iBR;AACF;;AazkBE;EACE,gCAAA;Ab4kBJ;;AaxkBA;EACE,yBTNmB;ESOnB,cAAA;Ab2kBF;AazkBE;EACE,4BAAA;EACA,4BAAA;Ab2kBJ;AaxkBE;EACE,4BAAA;Ab0kBJ;;AapkBE;;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AbwkBJ;AatkBI;;;;EAEE,kBAAA;Ab0kBN;AavkBI;;EACE,cRTK;ALmlBX;AavkBQ;;EACE,WRpBC;EQqBD,YRrBC;EQsBD,mBT5BF;ES6BE,gBAAA;Ab0kBV;AaxkBU;;EACE,mBT3CE;ES4CF,yBAAA;Ab2kBZ;AarkBI;;;;;;;;EAIE,wBAAA;EACA,yBAAA;EACA,iCAAA;Ab2kBN;AaxkBI;;;;EAEE,qEAAA;Ab4kBN;AaxkBI;;;;EAEE,qEAAA;EACA,yBAAA;Ab4kBN;AazkBI;;;;EAEE,wBAAA;Ab6kBN;Aa3kBM;;;;;;;EAEE,qBAAA;EACA,4BAAA;AbklBR;;Aa5kBA;EACE,0CAAA;Ab+kBF;Aa7kBE;EACE,cT7EI;ES8EJ,6CAAA;EACA,6BAAA;Ab+kBJ;Aa5kBE;EACE,eAAA;EACA,2BAAA;Ab8kBJ;Aa3kBE;EACE,cTxFI;AJqqBR;Aa3kBI;EACE,cTnGU;AJgrBhB;AazkBE;EACE,eAAA;EACA,sBAAA;Ab2kBJ;AazkBI;EAJF;IAKI,mBAAA;IACA,mBAAA;Eb4kBJ;AACF;Aa1kBI;EATF;IAUI,qBAAA;IACA,mBAAA;Eb6kBJ;AACF;Aa3kBI;EAdF;IAeI,mBAAA;IACA,mBAAA;Eb8kBJ;AACF;Aa3kBE;EACE,gBAAA;EACA,0BAAA;EAEA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;Ab4kBJ;Aa1kBI;EACE,aAAA;Ab4kBN;AaxkBI;EACE,iBAAA;Ab0kBN;AatkBE;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AbwkBJ;AarkBE;EACE,eAAA;AbukBJ;AapkBE;EACE,YAAA;AbskBJ;AapkBI;EACE,eAAA;EACA,uBAAA;EACA,sBAAA;AbskBN;AajkBE;EACE,yBAAA;AbmkBJ;;Aa/jBA;EACE,iBAAA;AbkkBF;AahkBE;EAHF;IAII,eAAA;EbmkBF;AACF;AajkBE;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AbmkBJ;AajkBI;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AbmkBN;AajkBM;EARF;IASI,qCAAA;IACA,kCAAA;EbokBN;AACF;AalkBM;EACE,8BAAA;EACA,oBAAA;EACA,qBAAA;AbokBR;AalkBQ;EACE,kBAAA;AbokBV;AajkBQ;EACE,kBAAA;AbmkBV;AahkBQ;EACE,kBAAA;AbkkBV;Aa/jBQ;EACE,kBAAA;AbikBV;Aa9jBQ;EACE,kBAAA;AbgkBV;Aa7jBQ;EACE,kBAAA;Ab+jBV;Aa5jBQ;EACE;IACE,kBAAA;Eb8jBV;Ea3jBQ;IACE,kBAAA;Eb6jBV;Ea1jBQ;IACE,kBAAA;Eb4jBV;EazjBQ;IACE,kBAAA;Eb2jBV;EaxjBQ;IACE,kBAAA;Eb0jBV;EavjBQ;IACE,kBAAA;EbyjBV;AACF;AavjBQ;EACE,qBAAA;EACA,sBAAA;EACA,uBAAA;AbyjBV;AatjBQ;EACE,aAAA;AbwjBV;AatjBQ;EACE,aAAA;AbwjBV;AatjBU;EACE,aAAA;AbwjBZ;AapjBQ;EACE,sBAAA;EACA,uBAAA;AbsjBV;;Aa9iBE;;EAEE,gCAAA;AbijBJ;Aa7iBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WRtQK;EQuQL,SAAA;Ab+iBN;Aa7iBM;EAPF;IAQI,mBAAA;IACA,uBAAA;EbgjBN;AACF;Aa9iBM;EAEE,aAAA;Ab+iBR;Aa5iBM;EACE,8BAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;Ab8iBR;Aa5iBQ;EATF;IAUI,gBAAA;IACA,6BAAA;Eb+iBR;AACF;Aa3iBI;EACE,qBR9SI;EQ+SJ,+BAAA;EACA,0BAAA;Ab6iBN;Aa3iBM;EACE,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;Ab6iBR;Aa3iBQ;EACE,sBAAA;EACA,YAAA;Ab6iBV;AaxiBI;EACE,QAAA;EACA,kBR5TK;ALs2BX;AaviBI;EACE,QAAA;AbyiBN;AaviBM;EACE,0BAAA;EACA,6BAAA;EACA,oBAAA;AbyiBR;AaniBI;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WR3UK;ALg3BX;AaniBM;EAPF;IAQI,mBAAA;EbsiBN;AACF;AaniBI;EACE,qBR7VI;EQ8VJ,2BAAA;EACA,sBAAA;AbqiBN;AaniBM;EALF;IAMI,UAAA;EbsiBN;AACF;AaniBI;;EAEE,aAAA;AbqiBN;;Ac15BE;EACE,iBAAA;EACA,YAAA;EACA,sBAAA;Ad65BJ;Ac35BI;EALF;IAMI,iBAAA;Ed85BJ;AACF;Ac55BI;EATF;IAUI,iBAAA;IACA,oBAAA;Ed+5BJ;AACF;Ac75BI;EAdF;IAeI,iBAAA;Edg6BJ;AACF;Ac95BI;EACE,sBAAA;Adg6BN;Ac95BM;EAHF;IAII,uBAAA;Edi6BN;AACF;Ac95BI;EACE,iCAAA;Adg6BN;Ac95BM;EAHF;IAII,8BAAA;Edi6BN;AACF;Ac95BI;EACE,cAAA;Adg6BN;Ac95BM;EAHF;IAII,UAAA;Edi6BN;AACF;Ac75BM;EACE,WAAA;EACA,oBAAA;Ad+5BR;Ac55BM;EACE,gBAAA;EACA,mBAAA;Ad85BR;Ac35BM;EACE,WAAA;EACA,cV/CG;EUgDH,SAAA;Ad65BR;Acz5BI;EACE,sBAAA;Ad25BN;Acx5BQ;EACE,aAAA;Ad05BV;Acv5BQ;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,yBVxEW;EUyEX,aTtDC;ESuDD,cTvDC;ALg9BX;Acv5BU;EARF;IASI,oBAAA;IACA,WTzDD;IS0DC,YT1DD;ELo9BT;AACF;Act5BU;EACE,yBVvFQ;EUwFR,4BAAA;Adw5BZ;Acj5BU;EACE,mDAAA;Adm5BZ;Ac54BU;EACE,mDAAA;Ad84BZ;Acv4BU;EACE,mDAAA;Ady4BZ;Acl4BU;EACE,oDAAA;Ado4BZ;Ac73BU;EACE,oDAAA;Ad+3BZ;Acx3BE;EACE,iBAAA;EACA,cAAA;Ad03BJ;Acx3BI;EACE,gBAAA;EACA,eAAA;Ad03BN;Acx3BM;EAJF;IAKI,eAAA;Ed23BN;AACF;Acz3BM;EARF;IASI,iBAAA;Ed43BN;AACF;Ac13BM;EAZF;IAaI,UAAA;Ed63BN;AACF;Acz3BQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;Ad23BV;Act3BQ;EACE,WAAA;EACA,gBAAA;Adw3BV;Act3BU;EAJF;IAKI,gBAAA;Edy3BV;AACF;Acv3BU;EARF;IASI,gBAAA;Ed03BV;AACF;Acx3BU;EAZF;IAaI,gBAAA;Ed23BV;AACF;Acz3BU;EAhBF;IAiBI,gBAAA;Ed43BV;AACF;Acv3BQ;EACE,WAAA;EACA,gBAAA;Ady3BV;Acv3BU;EAJF;IAKI,gBAAA;Ed03BV;AACF;Acx3BU;EARF;IASI,gBAAA;Ed23BV;AACF;Acz3BU;EAZF;IAaI,gBAAA;Ed43BV;AACF;Ac13BU;EAhBF;IAiBI,gBAAA;Ed63BV;AACF;Acv3BE;EACE,UAAA;Ady3BJ;Acv3BM;EACE,cVxNY;EUyNZ,gBAAA;Ady3BR;Act3BM;EACE,kBAAA;Adw3BR;Acn3BE;EACE,iBAAA;EACA,SAAA;Adq3BJ;Acj3BI;EACE,gCAAA;EACA,+BAAA;Adm3BN;Acj3BM;EAJF;IAKI,iCAAA;Edo3BN;AACF;Acl3BM;EARF;IASI,4BAAA;Edq3BN;AACF;Acn3BM;EACE,kDAAA;EACA,eAAA;Adq3BR;Acn3BQ;EAJF;IAKI,gBAAA;Eds3BR;AACF;Acl3BQ;EACE,cV/PU;EUgQV,kDAAA;EACA,kBAAA;Ado3BV;Acj3BQ;EACE,kBAAA;EACA,UAAA;Adm3BV;Acj3BU;EAJF;IAKI,gBAAA;Edo3BV;AACF;Acl3BU;EACE,SAAA;Ado3BZ;Acj3BU;EACE,iDAAA;EACA,kCAAA;Adm3BZ;;AeloCI;EACE,gBVDY;EUEZ,gCAAA;AfqoCN;AenoCM;EACE,gCAAA;EACA,SAAA;EACA,aVQG;AL6nCX;AenoCQ;EACE,6BAAA;AfqoCV;AehoCI;EACE,mBVFK;EUGL,gBAAA;EACA,6BAAA;AfkoCN;AehoCM;EACE,aAAA;AfkoCR;Ae9nCI;EACE,4DAAA;EACA,SAAA;AfgoCN;Ae7nCI;EACE,cXhCe;AJ+pCrB;Ae7nCM;EACE,cXpCM;AJmqCd;;AexnCE;EACE,yBXrCe;EWsCf,yBAAA;EACA,qBVhCM;EUiCN,qBAAA;EACA,2BAAA;EACA,kBAAA;Af2nCJ;;AgB5qCA;EACE,qBAAA;AhB+qCF;;AgB5qCA;EACE,qBAAA;AhB+qCF;;AgB5qCA;EACE,iBAAA;AhB+qCF;;AgB5qCA;EACE,iBAAA;AhB+qCF;;AgB5qCA;EACE,iBAAA;AhB+qCF;AgB7qCE;EACE,qBAAA;AhB+qCJ;;AgB3qCA;;;EAGE,uDAAA;AhB8qCF","sourcesContent":["/* \nTheme Name: 伊谷亜子公式ホームページTheme\nAuthor: 株式会社トータル・アシスト\n*/\n\n@forward \"./_mixins/\";\n@forward \"./00-global/\";\n@forward \"./01-atoms/\";\n@forward \"./02-molecules/\";\n@forward \"./03-organisms/\";\n@forward \"./04-templates/\";\n@forward \"./05-pages/\";\n@forward \"./06-overrides/\";\n","@use \"../00-global\" as *;\n\n.wp-block-button__link {\n  border-radius: 0;\n\n  &:hover {\n    background-color: $col-primary-light !important;\n    border: 2px solid $col-primary-darker !important;\n    color: $white !important;\n    transition: all 0.5s 0s ease;\n  }\n}\n","@use \"../00-global\" as *;\n\nhtml {\n  scroll-behavior: smooth;\n  height: 100%;\n}\n\nbody {\n  padding: 0;\n}\n\n.wp-site-blocks {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\nmain {\n  flex: 1;\n}\n\n.global-footer {\n  flex-shrink: 0;\n}\n\nsection {\n  margin-block-start: 0 !important;\n  padding: $num-56px 0;\n  \n  @media screen and (min-width: $screen-small) {\n    padding: $num-80px 0;\n  }\n\n  & > *:not(h2, ul, iframe, .ako-hero-slide, .ako-latest-disc__inner, .ako-latest-disc__container, .ako-youtube .feedzy-rss) {\n    max-width: $screen-large !important;\n    padding: 0 $num-16px;\n\n    @media screen and (min-width: $screen-large) {\n      padding: 0;\n    }\n  }\n\n  & > h2 {\n    max-width: $screen-large !important;\n  }\n\n  & > ul {\n    max-width: $screen-large !important;\n    padding: 0 $num-16px;\n\n    @media screen and (min-width: $screen-large) {\n      padding: 0;\n    }\n  }\n}\n","@use \"../00-global\" as *;\n\na {\n  color: $col-primary-darker;\n\n  &:hover {\n    color: $col-primary;\n  }\n}\n\n.ako-links {\n  h2 {\n    margin: 0 auto $num-40px !important;\n  }\n\n  &__top {\n    &--spotify,\n    &--amazon-music,\n    &--apple-music {\n      flex: 1 1 0;\n      \n      a {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: $num-8px;\n        background-color: $white !important;\n        border: 4px solid $white !important;\n        border-radius: $num-8px;\n        padding: $num-16px $num-24px;\n        line-height: 1;\n        box-sizing: border-box;\n\n        &:before {\n          display: inline-block;\n          content: \"\";\n          mask-size: $num-48px $num-48px;\n          background-color: $col-primary-darker;\n          width: $num-48px;\n          height: $num-48px;\n        }\n\n        &:hover {\n          border: $num-4px solid $col-secondary !important;\n          background-color: $white !important;\n          color: $col-primary-darker !important;\n          transition: all 0.5s 0s ease;\n        }\n      }\n    }\n\n    &--spotify {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/logo_spotify.svg\");\n        }\n      }\n    }\n\n    &--amazon-music {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/logo_amazon-music.svg\");\n        }\n      }\n    }\n\n    &--apple-music {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/logo_apple-music.svg\");\n        }\n      }\n    }\n  }\n\n  &__bottom {\n    margin: $num-40px auto 0 !important;\n\n    figure {\n      border: $num-4px solid transparent;\n      border-radius: $num-16px;\n      box-sizing: border-box;\n      overflow: hidden;\n\n      &:hover {\n        border: $num-4px solid $col-secondary;\n        transition: all 0.5s 0s ease;\n      }\n    }\n  }\n\n  &__top,\n  &__bottom {\n    flex-direction: column;\n    \n\n    @media screen and (min-width: $screen-medium) {\n      flex-direction: row;\n    }\n  }\n\n  &__min {\n    margin: $num-40px 0 0 !important;\n    padding: $num-40px 0;\n\n    p {\n      margin: 0 0 $num-16px;\n    }\n  }\n}\n","// Brand Colours\n$col-primary-light: #9076C5;\n$col-primary: #431F89;\n$col-primary-darker: #181830;\n\n$col-secondary: #FFED00;\n\n$col-tertiary: #FFC300;\n\n$col-gray-lighter: #F2F2F2;\n$col-gray-light: #D9D9D9;\n$col-gray: #999999;\n\n$white: #FFFFFF;\n\n// Font Colours\n$col-heading: $col-primary-darker;\n$col-copy: $col-primary-darker;\n\n// UI Colours\n$col-border: $col-primary-darker;\n$col-background: $col-gray-lighter;\n\n// Third party\n$col-line: #06C755;\n","$root-size: 16;\n\n$screen-xsmall:   520px !default; // Mobile\n$screen-small:    600px !default; // Mini Tablet\n$screen-medium:   782px !default; // Tablet - was 768px\n$screen-large:    1040px !default; // Desktop - was 960px\n$screen-xlarge:   1200px !default; // Large Desktop\n$screen-max:      2000px !default; // TV\n\n$screen-smartphone-portrait: 601px !default;\n\n$max-width-s: calc(640 / $root-size * 1rem);\n$max-width-m: calc(960 / $root-size * 1rem);\n$max-width-l: calc(1040 / $root-size * 1rem);\n\n$num-4px: 0.25rem;\n$num-8px: 0.5rem;\n$num-12px: 0.75rem;\n$num-14px: 0.875rem;\n$num-16px: 1rem;\n$num-18px: 1.125rem;\n$num-20px: 1.25rem;\n$num-24px: 1.5rem;\n$num-28px: 1.75rem;\n$num-32px: 2rem;\n$num-36px: 2.25rem;\n$num-40px: 2.5rem;\n$num-48px: 3rem;\n$num-56px: 3.5rem;\n$num-64px: 4rem;\n$num-72px: 4.5rem;\n$num-80px: 5rem;\n$num-96px: 6rem;\n","@use \"../00-global\" as *;\n\nh1 {\n  font-size: clamp($num-36px, 1.5rem + 2.31vw, $num-48px);\n  padding: $num-40px 0 0;\n\n  @media screen and (min-width: $screen-medium) {\n    padding: $num-80px 0 0;\n  }\n}\n\nh2 {\n  font-size: clamp($num-32px, 1.5rem + 1.54vw, $num-40px);\n}\n\nh3 {\n  font-size: clamp($num-24px, 1rem + 1.54vw, $num-32px);\n}\n\nh4 {\n  font-size: clamp($num-20px, 1rem + 0.77vw, $num-24px);\n}\n\nh5 {\n  font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px);\n}\n\nh6 {\n  font-size: clamp($num-14px, 0.75rem + 0.38vw, $num-16px);\n}\n\np,\nli {\n  font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px);\n  line-height: 160%;\n}\n\n.controlled-line-break {\n  display: inline;\n\n  @media screen and (min-width: $screen-medium) {\n    display: inline-block;\n  }\n}\n","@use \"../00-global\" as *;\n\n.ako-event-list {\n  &__group {\n    margin: 0;\n    padding: 0;\n  }\n\n  &__item {\n    list-style: none;\n\n    &--date {\n      font-size: $num-16px;\n    }\n\n    &--title {\n      font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px) !important;\n      margin: 0;\n    }\n  }\n}\n","@use \"../00-global\" as *;\n\n.tab-switcher {\n  &__container {\n\n  }\n\n  &__tab {\n    border-bottom: 1px solid $col-primary-darker;\n    margin: 0 0 $num-40px;\n\n    ul {\n      display: flex;\n      flex-direction: row;\n      justify-content: center;\n      gap: $num-16px;\n      margin: 0;\n      padding: 0;\n\n      li {\n        border: 1px solid $col-primary-darker;\n        border-bottom: 0;\n        box-sizing:content-box;\n        list-style: none;\n        padding: $num-8px $num-24px;\n        cursor: pointer;\n\n        &.current {\n          background-color: $col-primary;\n          color: $white;\n\n          &:hover {\n            background-color: $col-primary;\n            transition: all 0.5s 0s ease;\n          }\n        }\n\n        &:hover {\n          background-color: $col-primary-light;\n          color: $white;\n          transition: all 0.5s 0s ease;\n        }\n      }\n    }\n  }\n\n  &__table {\n    overflow: hidden;\n      \n    .table-item {\n      height: 0;\n      visibility: hidden;\n      opacity: 0;\n\n      &.current {\n        height: 100%;\n        visibility: visible;\n        opacity: 1;\n        transition: all 0.5s 0s ease;\n      }\n\n      h3 {\n        margin: 0 0 $num-40px;\n      }\n\n      h4 {\n        font-size: clamp($num-14px, 0.75rem + 0.38vw, $num-16px);\n      }\n\n      p {\n        font-size: clamp($num-14px, 0.75rem + 0.38vw, $num-16px);\n\n      }\n    }\n  }\n}\n","@use \"../00-global\" as *;\n\n.form-general {\n  &__container {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    max-width: $screen-small;\n    margin: 0 auto;\n\n    div {\n      p {\n        display: flex;\n        flex-direction: column;\n        gap: $num-8px;\n\n        > label {\n          font-weight: 700;\n        }\n      }\n    }\n\n\n\n    input[type=text],\n    input[type=email],\n    input[type=date],\n    input[type=number],\n    textarea{\n      font-size: $num-16px;\n      padding: $num-12px $num-8px;\n      box-sizing: border-box;\n      width: 100%;\n    }\n  \n    input[type=submit] {\n      background: $col-primary;\n      border: 2px solid $col-primary;\n      color: $white;\n      font-size: $num-20px;\n      padding: $num-12px $num-8px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: $col-primary-light;\n        transition: all 0.5s 0s ease;\n      }\n    }\n\n    input[type=radio],\n    input[type=checkbox],\n    input[type=number],\n    input[type=date] {\n\n    }\n  }\n\n  &__name {\n\n  }\n\n  &__email {\n\n  }\n\n  &__type-of-inquiry {\n\n  }\n\n  &__message-for-general-inquiry {\n\n  }\n\n  &__name-of-event {\n\n  }\n\n  &__date-of-event {\n\n  }\n\n  &__number-of-ticket {\n\n  }\n\n  &__message-for-ticket-inquiry {\n\n  }\n\n  &__concent-for-privacy-policy {\n    p {\n      margin: 0 !important;\n    }\n\n    div {\n      p {\n        font-size: $num-14px;\n        margin-top: $num-8px !important;\n      }\n    }\n  }\n\n  &__submit {\n    p {\n      margin: 0 !important;\n    }\n  }\n}\n\n// Override starts\n.wpcf7-list-item {\n  margin: 0;\n}\n\n.wpcf7-radio {\n  display: flex;\n  flex-direction: row;\n  gap: $num-16px;\n}\n\n.wpcf7-not-valid-tip {\n  font-size: $num-14px;\n}\n// Override ends","@use \"../00-global\" as *;\n\n.global-footer {\n  background: linear-gradient($col-primary, $col-primary-darker);\n  color: $white;\n  padding: $num-80px 0;\n\n  &__inner {\n    gap: $num-24px !important;\n    margin: 0 $num-16px auto;\n\n    @media screen and (min-width: $screen-xlarge) {\n      margin: 0 $num-40px auto;\n    }\n  }\n\n  &__nav {\n    gap: $num-16px;\n    justify-content: center;\n\n    a {\n      span {\n        text-decoration: underline;\n      }\n      \n      &:hover {\n        span {\n          color: $col-secondary;\n          transition: all 0.5s 0s ease;\n        }\n      }\n    }\n\n  }\n\n  p,\n  span {\n    font-size: $num-16px !important;\n    line-height: 140%;\n  }\n}\n","@use \"../00-global\" as *;\n\n.global-header {\n  background: linear-gradient($col-primary, $col-primary-darker);\n  padding: $num-16px 0;\n\n  &__inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap !important;\n    justify-content: space-between !important;\n    margin: 0 $num-16px auto;\n    gap: 24px !important;\n\n    @media screen and (min-width: $screen-small) {\n      justify-content: center !important;\n    }\n\n    @media screen and (min-width: $screen-large) {\n      flex-wrap: nowrap !important;\n      justify-content: space-between !important;\n    }\n\n    @media screen and (min-width: $screen-xlarge) {\n      margin: 0 $num-40px auto;\n    }\n  }\n\n  &__logo {\n    min-width: $num-80px !important;\n    width: $num-80px !important;\n  }\n\n  &__nav {\n    justify-content: space-between;\n    gap: $num-24px !important;\n    order: 3;\n    width: 100%;\n\n    @media screen and (min-width: $screen-small) {\n      justify-content: center;\n    }\n\n    @media screen and (min-width: $screen-large) {\n      gap: $num-32px !important;\n      order: 2;\n    }\n\n    @media screen and (min-width: $screen-xlarge) {\n      gap: $num-40px !important;\n    }\n\n    &--profile,\n    &--discography,\n    &--blog,\n    &--schedule {\n      flex: 0 1 calc((100% - ($num-24px * 3)) / 4);\n\n      @media screen and (min-width: $screen-small) {\n        flex: 0 1 auto;\n      }\n\n      a {\n        display: flex !important;\n        flex-direction: column;\n        align-items: center;\n        width: 100%;\n\n        @media screen and (min-width: $screen-small) {\n          flex-direction: row;\n        }\n\n        span {\n          color: $white;\n          font-size: $num-12px;\n          font-weight: 700;\n          line-height: 1;\n\n          @media screen and (min-width: $screen-small) {\n            font-size: $num-16px;\n          }\n        }\n\n        &:before {\n          content: \"\";\n          display: inline-block;\n          mask-size: $num-32px $num-32px;\n          background-color: $white;\n          width: $num-32px;\n          height: $num-32px;\n          margin: 0 0 $num-8px 0;\n\n          @media screen and (min-width: $screen-small) {\n            margin: 0 $num-8px 0 0;\n          }\n        }\n\n        &:hover {\n          span {\n            color: $col-secondary;\n            transition: all 0.5s 0s ease;\n          }\n\n          &:before {\n            background-color: $col-secondary;\n            transition: all 0.5s 0s ease;\n          }\n        }\n      }\n    }\n\n    &--profile {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_profile.svg\");\n        }\n      }\n    }\n\n    &--discography {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_discography.svg\");\n        }\n      }\n    }\n\n    &--blog {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_blog.svg\");\n        }\n      }\n    }\n\n    &--schedule {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_schedule.svg\");\n        }\n      }\n    }\n  }\n\n  &__collective {\n    gap: $num-8px !important;\n    order: 2;\n    \n    @media screen and (min-width: $screen-large) {\n      order: 3;\n    }\n  }\n\n  &__sns {\n    gap: $num-8px !important;\n\n    a {\n      svg {\n        display: none;\n      }\n\n      &:before {\n        content: \"\";\n        display: inline-block;\n        mask-size: $num-24px $num-24px;\n        background-color: $white;\n        width: $num-24px;\n        height: $num-24px;\n\n        @media screen and (min-width: $screen-small) {\n          mask-size: $num-24px $num-24px;\n          width: $num-24px;\n          height: $num-24px;\n        }\n      }\n\n\n      &:hover {\n        &:before {\n          background-color: $col-secondary;\n          transition: all 0.5s 0s ease;\n        }\n      }\n    }\n\n    &--youtube {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_sns--youtube.svg\");\n        }\n      }\n    }\n\n    &--instagram {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_sns--instagram.svg\");\n        }\n      }\n    }\n\n    &--x {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_sns--x.svg\");\n        }\n      }\n    }\n\n    &--facebook {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_sns--facebook.svg\");\n        }\n      }\n    }\n\n    &--tiktok {\n      a {\n        &:before {\n          mask-image: url(\"/assets/images/icon_sns--tiktok.svg\");\n        }\n      }\n    }\n  }\n\n  &__subnav {\n    gap: $num-16px !important;\n\n    li {\n      line-height: 1;\n    }\n    \n    a {\n      display: inline-block;\n      background-color: rgba(225, 255, 255, .28);\n      border-radius: $num-4px;\n      padding: $num-8px;\n      \n      span {\n        color: $white;\n        font-size: $num-12px;\n        font-weight: 700;\n      }\n\n      &:hover {\n        background-color: $col-secondary;  \n        transition: all 0.5s 0s ease;\n\n        span {\n          &:hover {\n            color: $col-primary-darker;\n            transition: all 0.5s 0s ease;\n          }\n        }\n      }\n    }\n\n    &--store {\n      font-size: $num-12px !important;\n    }\n  }\n}\n\n// WordPressデフォルトのSNS用背景を消す\n.wp-social-link {\n  background-color: transparent !important;\n}\n","@use \"../00-global\" as *;\n\n$FLEX_GAP: $num-40px;\n\n.page__gallery {\n  .ako-gallery {\n    &__group {\n      flex-direction: column;\n      gap: $FLEX_GAP !important;\n\n      @media screen and (min-width: $screen-small) {\n        flex-direction: row;\n        flex-wrap: wrap;\n      }\n\n      .wp-block-image {\n        flex: 0 0 calc(100% - ($num-16px * 2)) !important;\n        width: unset !important;\n        overflow: hidden;\n        aspect-ratio: 1/1;\n\n\n        @media screen and (min-width: $screen-small) {\n          flex: 0 0 calc((100% - ($FLEX_GAP * 1)) / 2) !important;\n        }\n\n        @media screen and (min-width: $screen-medium) {\n          flex: 0 0 calc((100% - ($FLEX_GAP * 2)) / 3) !important;\n        }\n\n        @media screen and (min-width: $screen-large) {\n          flex: 0 0 calc((100% - ($FLEX_GAP * 3)) / 4) !important;\n        }\n      }\n    }\n  }\n}\n","@use \"../00-global\" as *;\n\n.home {\n  h2 {\n    margin: 0 auto $num-40px !important;\n  }\n}\n\n.ako-hero-slide {\n  background-color: $col-primary-darker;\n  margin: 0 auto;\n  \n  &__inner {\n    max-width: 1600px !important;\n    max-height: 900px !important;\n  }\n\n  .flex-viewport {\n    max-height: 900px !important;\n  }\n}\n\n.ako-hero-slide,\n.ako-latest-disc {\n  .flexslider {\n    margin: 0;\n    position: relative;\n    overflow: hidden;\n\n    .flex-viewport,\n    .flex-control-nav {\n      position: absolute;\n    }\n\n    .flex-control-nav {\n      bottom: $num-40px;\n\n      li {\n        a {\n          width: $num-16px;\n          height: $num-16px;\n          background: $white;\n          margin: 0 $num-8px;\n\n          &.flex-active {\n            background: $col-primary;\n            border: 2px solid $white;\n          }\n        }\n      }\n    }\n\n    .flex-prev,\n    .flex-next,\n    .flex-prev:focus,\n    .flex-next:focus {\n      width: $num-40px !important;\n      height: $num-40px !important;\n      background-size: cover !important;\n    }\n\n    .flex-prev,\n    .flex-prev:focus {\n      background-image: url(\"/assets/images/icon_chevron.svg\") !important;\n      \n    }\n\n    .flex-next,\n    .flex-next:focus {\n      background-image: url(\"/assets/images/icon_chevron.svg\") !important;\n      transform: rotate(180deg);\n    }\n\n    .flex-prev,\n    .flex-next {\n      opacity: .75 !important;\n\n      &:hover,\n      &:focus {\n        opacity: 1 !important;\n        transition: all 0.5s 0s ease;\n      }\n    }\n  }\n}\n\n.ako-latest-disc {\n  background: linear-gradient(#000, $col-primary-darker);\n\n  h2 {\n    color: $white;\n    font-size: clamp($num-24px, 1rem + 1.54vw, $num-32px);\n    margin: 0 0 $num-24px !important;\n  }\n\n  h4 {\n    font-size: 16px;\n    margin: $num-16px 0 0 !important;\n  }\n\n  a {\n    color: $white;\n\n    &:hover {\n      color: $col-secondary;\n    }\n  }\n\n  &__inner {\n    padding: 0 $num-16px;\n    flex-direction: column;\n\n    @media screen and (min-width: $screen-small) {\n      padding: 0 0 0 $num-16px;\n      flex-direction: row;\n    }\n\n    @media screen and (min-width: $screen-medium) {\n      padding: 0 0 0 $num-40px;\n      flex-direction: row;\n    }\n\n    @media screen and (min-width: $screen-max) {\n      padding: 0 0 0 $num-80px;\n      flex-direction: row;\n    }\n  }\n\n  &__container {\n    overflow: scroll;\n    max-width: 100% !important;\n\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n  \n    &:-webkit-scrollbar {\n      display: none;\n    }\n\n\n    &.active {\n      cursor: ew-resize;\n    }\n  }\n\n  &__post {\n    display: flex !important;\n    flex-direction: row;\n    width: max-content;\n    box-sizing: content-box;\n  }\n\n  .wp-block-post-template {\n    max-width: none;\n  }\n\n  &__item {\n    width: 320px;\n\n    img {\n      user-drag: none;\n      -webkit-user-drag: none;\n      -moz-user-select: none;\n    }\n\n  }\n\n  .wp-block-button__link {\n    color: $white !important;\n  }\n}\n\n.ako-youtube {\n  padding: $num-40px 0;\n\n  @media screen and (min-width: $screen-medium) {\n    padding: $num-80px 0;\n  }\n\n  .feedzy-rss {\n    width: 100%;\n    height: 100%;\n    margin: 0 auto $num-40px !important;\n\n    ul {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-template-rows: repeat(6, 1fr);\n      grid-column-gap: 0px;\n      grid-row-gap: 0px;\n      margin: 0 !important;\n\n      @media screen and (min-width: $screen-medium) {\n        grid-template-columns: repeat(3, 1fr);\n        grid-template-rows: repeat(3, 1fr);\n      }\n\n      li {\n        border-bottom: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n\n        &:first-child {\n          grid-area: 1 / 1 / 3 / 3;\n        }\n\n        &:nth-child(2) {\n          grid-area: 3 / 1 / 5 / 3;\n        }\n\n        &:nth-child(3) {\n          grid-area: 5 / 1 / 6 / 2;\n        }\n\n        &:nth-child(4) {\n          grid-area: 5 / 2 / 6 / 3;\n        }\n\n        &:nth-child(5) {\n          grid-area: 6 / 1 / 7 / 2;\n        }\n\n        &:last-child {\n          grid-area: 6 / 2 / 7 / 3;\n        }\n\n        @media screen and (min-width: $screen-medium) {\n          &:first-child {\n            grid-area: 1 / 1 / 3 / 3;\n          }\n  \n          &:nth-child(2) {\n            grid-area: 1 / 3 / 2 / 4;\n          }\n  \n          &:nth-child(3) {\n            grid-area: 2 / 3 / 3 / 4;\n          }\n  \n          &:nth-child(4) {\n            grid-area: 3 / 1 / 4 / 2;\n          }\n  \n          &:nth-child(5) {\n            grid-area: 3 / 2 / 4 / 3;\n          }\n  \n          &:last-child {\n            grid-area: 3 / 3 / 4 / 4;\n          }\n        }\n        a {\n          display: inline-block;\n          width: 100% !important;\n          height: 100% !important;\n        }\n\n        .title {\n          display: none;\n        }\n        .rss_content {\n          display: none;\n            \n          small {\n            display: none;\n          }\n        }\n\n        .rss_image {\n          width: 100% !important;\n          height: 100% !important;\n        }\n      }\n    }\n  }\n}\n\n.ako-sns {\n  .feedzy-rss,\n  #sb_instagram {\n    margin: 0 auto $num-40px !important;\n  }\n\n  &__ameblo {\n    ul {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: $num-40px;\n      margin: 0;\n\n      @media screen and (min-width: $screen-medium) {\n        flex-direction: row;\n        align-items: flex-start;\n      }\n\n      &:before,\n      &:after {\n        content: none;\n      }\n      \n      .rss_item {\n        border-bottom: none !important;\n        display: flex !important;\n        flex-direction: column;\n        max-width: 320px;\n        margin: 0 !important;\n        padding: 0 !important;\n        overflow: visible;\n\n        @media screen and (min-width: $screen-medium) {\n          overflow: hidden;\n          flex: 1 1 calc(33.33% - $num-80px);\n        }\n      }\n    }\n\n    .rss_image {\n      border-radius: $num-8px;\n      margin: 0 0 $num-24px 0 !important;\n      position: unset !important;\n\n      a {\n        position: unset !important;\n        display: inline-block;\n        width: 320px;\n        height: 320px;\n\n        img {\n          width: auto !important;\n          height: 100%;\n        }\n      }\n    }\n\n    .title {\n      order: 2;\n      font-size: $num-20px;\n    }\n\n    .rss_content {\n      order: 1;\n\n      small {\n        font-size: $num-16px !important;\n        font-style: normal !important;\n        margin: 0 0 $num-8px 0;\n      }\n    }\n  }\n\n  &__instagram {\n    #sbi_images {\n      float: none !important;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: $num-40px;\n\n      @media screen and (min-width: $screen-medium) {\n        flex-direction: row;\n      }\n    }\n\n    .sbi_item {\n      border-radius: $num-8px;\n      max-width: 320px !important;\n      width: 100% !important;\n\n      @media screen and (min-width: $screen-medium) {\n        width: 33%;\n      }\n    }\n\n    #sbi_load,\n    .sb_instagram_header {\n      display: none;\n    }\n  }\n}\n","@use \"../00-global\" as *;\n\n.page__profile {\n  .ako-profile-hero {\n    min-height: 320px;\n    height: 100%;\n    margin: $num-40px 0 120px;\n\n    @media screen and (min-width: $screen-small) {\n      min-height: 320px;\n    }\n  \n    @media screen and (min-width: $screen-medium) {\n      min-height: 400px;\n      margin: $num-80px 0 120px;\n    }\n  \n    @media screen and (min-width: $screen-xlarge) {\n      min-height: 660px;\n    }\n  \n    img {\n      height: 64% !important;\n  \n      @media screen and (min-width: $screen-small) {\n        height: 100% !important;  \n      }\n    }\n  \n    &__container {\n      flex-direction: column !important;\n  \n      @media screen and (min-width: $screen-small) {\n        flex-direction: row !important;\n      }\n    }\n  \n    &__left {\n      padding: 160px;\n  \n      @media screen and (min-width: $screen-small) {\n        padding: 0;    \n      }\n    }\n  \n    &__right {\n      h2 {\n        float: left;\n        margin: 0 $num-8px 0 0;\n      }\n\n      h3 {\n        font-weight: 400;\n        margin: $num-12px 0 0;\n      }\n\n      p {\n        clear: both;\n        color: $col-gray;\n        margin: 0;\n      }\n    }\n  \n    &__sns {\n      gap: $num-8px !important;\n  \n      a {\n        svg {\n          display: none;\n        }\n  \n        &:before {\n          content: \"\";\n          display: inline-block;\n          mask-size: $num-24px $num-24px;\n          background-color: $col-primary-darker;\n          width: $num-24px;\n          height: $num-24px;\n  \n          @media screen and (min-width: $screen-small) {\n            mask-size: $num-32px $num-32px;\n            width: $num-32px;\n            height: $num-32px;\n          }\n        }\n  \n        &:hover {\n          &:before {\n            background-color: $col-primary-light;\n            transition: all 0.5s 0s ease;\n          }\n        }\n      }\n  \n      &--youtube {\n        a {\n          &:before {\n            mask-image: url(\"/assets/images/icon_sns--youtube.svg\");\n          }\n        }\n      }\n  \n      &--instagram {\n        a {\n          &:before {\n            mask-image: url(\"/assets/images/icon_sns--instagram.svg\");\n          }\n        }\n      }\n  \n      &--x {\n        a {\n          &:before {\n            mask-image: url(\"/assets/images/icon_sns--x.svg\");\n          }\n        }\n      }\n  \n      &--facebook {\n        a {\n          &:before {\n            mask-image: url(\"/assets/images/icon_sns--facebook.svg\");\n          }\n        }\n      }\n  \n      &--tiktok {\n        a {\n          &:before {\n            mask-image: url(\"/assets/images/icon_sns--tiktok.svg\");\n          }\n        }\n      }\n    }\n  }\n  \n  .ako-intro {\n    max-width: 2000px;\n    margin: 0 auto;\n    \n    .wp-block-media-text {\n      overflow: hidden;\n      padding: 0 $num-16px;\n  \n      @media screen and (min-width: $screen-small) {\n        padding: 0 $num-16px;\n      }\n  \n      @media screen and (min-width: $screen-medium) {\n        padding: 0 $num-40px;\n      }\n  \n      @media screen and (min-width: $screen-max) {\n        padding: 0;\n      }\n  \n      &:first-child,\n      &:last-child {\n        figure {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n      \n      &:first-child {\n        img {\n          width: 100%;\n          max-width: 444px;\n  \n          @media screen and (min-width: $screen-small) {\n            max-width: 444px;\n          }\n  \n          @media screen and (min-width: $screen-medium) {\n            max-width: 444px;\n          }\n  \n          @media screen and (min-width: $screen-large) {\n            max-width: 444px;\n          }\n  \n          @media screen and (min-width: $screen-xlarge) {\n            max-width: 888px;\n          }\n        }\n      }\n  \n      &:last-child {\n        img {\n          width: 100%;\n          max-width: 400px;\n  \n          @media screen and (min-width: $screen-small) {\n            max-width: 400px;\n          }\n  \n          @media screen and (min-width: $screen-medium) {\n            max-width: 400px;\n          }\n  \n          @media screen and (min-width: $screen-large) {\n            max-width: 400px;\n          }\n  \n          @media screen and (min-width: $screen-xlarge) {\n            max-width: 800px;\n          }\n        }\n      }\n    }\n  }\n  \n  .ako-extra {\n    padding: 0;\n    &__items {\n      h4 {\n        color: $col-primary-light;\n        margin: 0 0 $num-16px;\n      }\n  \n      p {\n        margin: 0 0 $num-40px;\n      }\n    }\n  }\n  \n  .ako-snapshots {\n    gap: 0 !important;\n    margin: 0;\n  }\n  \n  .ako-history {\n    &__group {\n      border-bottom: 1px solid $col-primary-darker;\n      padding: $num-40px $num-16px !important;\n  \n      @media screen and (min-width: $screen-medium) {\n        padding: $num-56px $num-40px !important;\n      }\n  \n      @media screen and (min-width: $screen-large) {\n        padding: $num-56px 0 !important;\n      }\n  \n      &--left {\n        font-size: clamp($num-20px, 0.977rem + 1.36vw, $num-32px);\n        min-width: 80px;\n  \n        @media screen and (min-width: $screen-medium) {\n          min-width: 258px;\n        }\n      }\n    \n      &--right {\n        h4 {\n          color: $col-primary-light;\n          font-size: clamp($num-14px, 0.75rem + 0.38vw, $num-16px);\n          margin: 0 0 $num-8px;\n        }\n  \n        ul {\n          margin: 0 0 $num-40px;\n          padding: 0;\n  \n          @media screen and (min-width: $screen-medium) {\n            margin: 0 0 $num-80px;\n          }\n  \n          &:last-child {\n            margin: 0;\n          }\n  \n          li {\n            font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px);\n            margin: 0 0 $num-16px $num-24px !important;\n          }\n        }\n      }\n    }\n  }\n}\n\n","@use \"../00-global\" as *;\n\n.ako-schedule {\n  &__table {\n    ul {\n      max-width: $screen-medium;\n      margin: 0 auto $num-40px !important;\n\n      li {\n        border-bottom: 1px solid $col-primary-darker;\n        margin: 0;\n        padding: $num-16px;\n\n        &:first-child {\n          border-top: 1px solid $col-primary-darker;\n        }\n      }\n    }\n\n    .tribe-events-schedule__datetime {\n      font-size: $num-14px;\n      font-weight: 400;\n      margin: 0 0 $num-8px !important;\n\n      & > *:not(span:first-child) {\n        display: none; // スケジュールプラグイン初期に表示される要素の、日付以外を非表示\n      }\n    }\n\n    h4 {\n      font-size: clamp($num-16px, 0.75rem + 0.77vw, $num-20px) !important;\n      margin: 0;\n    }\n\n    a {\n      color: $col-primary-darker;\n\n      &:hover {\n        color: $col-primary;\n      }\n    }\n  }\n}\n\n.single-tribe_events {\n  .tribe-events-schedule {\n    background-color: $col-gray-lighter;\n    border: 1px solid $col-gray-light;\n    border-radius: $num-8px;\n    margin: $num-24px 0 $num-80px;\n    padding: $num-8px $num-16px $num-24px;\n    text-align: center;\n  }  \n}\n","@use \"../00-global\" as *;\n\n.wp-site-blocks > * + * {\n  margin-block-start: 0;\n}\n\n.wp-block-group.is-layout-constrained > * + * {\n  margin-block-start: 0;\n}\n\n.wp-block-columns {\n  box-sizing: unset;\n}\n\n.wp-block-group {\n  box-sizing: unset;\n}\n\n.wp-block-media-text {\n  box-sizing: unset;\n\n  &__content {\n    padding: 0 !important;\n  }\n}\n\n:where(body .is-layout-flex),\n:where(body .is-layout-grid),\n.wp-block-media-text {\n  gap: clamp($num-16px, -0.039rem + 5.19vw, $num-40px) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
